export default "__VITE_ASSET__teRIyZzN__"